import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';

export const ProductTaggingModal: StyleRule = ({ theme }) => ({
    width: pxToRem(436),
    height: 'auto',
    backgroundColor: theme.siteVariables.colors.white['100A'],
    boxShadow: `0px 14px 24px 2px rgba(0, 0, 0, 0.08)`,
});

export const ModalHeader: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([0, 24]),
    padding: pxArrayToRem([34, 0, 4, 0]),
    borderBottom: `2px solid ${theme.siteVariables.colors.charcoal['250']}`,
    justifyContent: 'space-between',
});

export const ModalBody: StyleRule = () => ({
    padding: pxToRem(24),
});

export const ModalFooter: StyleRule = () => ({
    padding: pxArrayToRem([0, 24, 24]),
});

export const Title: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.charcoal['250'],
    fontWeight: theme.siteVariables.textStyles.Text.Medium65.fontWeight,
    letterSpacing: theme.siteVariables.letterSpacingMedium,
    height: pxToRem(30),
    margin: pxToRem(8),
});

export const Message: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.primitive.black,
    lineHeight: theme.siteVariables.lineHeightSmall,
    '& strong': {
        fontWeight: theme.siteVariables.textStyles.Text.Medium65.fontWeight,
    },
});
